<template>
  <v-card class="overflow-hidden mx-auto" height="100" max-width="500">
    <LoyKrathongTheme v-if="false" />

    <v-bottom-navigation
      v-if="listMenu.length > 0"
      height="70"
      fixed
      v-model="value"
      app
      class="d-flex justify-center"
    >
      <v-btn
        v-for="(item, index) in listMenu"
        :key="index"
        :style="
          item.route_allow.includes($route.name)
            ? `border-top: 2px solid ${site.color};`
            : ''
        "
        class="my-auto footer"
        @click="onClickMenu(item)"
      >
        <span class="mt-2" :style="{ color: textColor }">{{
          mappingTextMenu(item)
        }}</span>

        <v-badge overlap color="red" dot :value="item.noti ? true : false">
          <MenuSymbol
            position="bottom_nav_bar"
            :name="item.name"
            :type="item.type || 'default'"
            :symbol="item.symbol || ''"
            :color="site.color"
            :is_display="true"
            :outlined_box="false"
            :size="36"
          />
        </v-badge>
      </v-btn>
    </v-bottom-navigation>
  </v-card>
</template>

<script>
import { mapState } from "vuex";
import MenuSymbol from "@/components/menu/menu-symbol.vue";
import LoyKrathongTheme from "@/components/theme/loy-krathong.vue";

export default {
  inject: ["isAppLoading"],
  components: {
    LoyKrathongTheme,
    MenuSymbol,
  },
  data() {
    return {
      value: 0,
    };
  },
  methods: {
    mappingTextMenu(param) {
      let label = param.name;
      const mapping = {
        main: "home",
        mission: "activity",
        reward: "reward",
        transport: "tracking",
        account: "account",
        // Extend
        chat: { name: "menuChatRoom", route: "chat-room" },
        report: { name: "menuInformationCenter", route: "report" },
        campaign: { name: "menuCampaign", route: "campaign" },
        request: { name: "menuRequest", route: "request" },
        warranty: { name: "menuWarranty", route: "warranty" },
        other: { name: "other", route: "other" },
      };
      if (mapping[param.name]) {
        label = this.$t(mapping[param.name]?.name || mapping[param.name]);
      }
      return label;
    },
    onClickMenu(param) {
      const curName = this.$router.currentRoute.name;
      const routerName = param.route;
      if (curName != routerName) {
        this.isAppLoading(true);
        this.$router
          .push({
            name: routerName,
          })
          .then(() => {
            if (["transport"].includes(routerName)) {
              this.isAppLoading(false);
            }
          });
      }
    },
  },
  computed: {
    ...mapState("defaultSystem", ["site", "notificationData"]),
    textColor() {
      return this.site.color;
    },
    listMenu() {
      let list = [];
      if (this.site?.bottom_nav_bar?.menu?.length > 0) {
        list = this.site?.bottom_nav_bar?.menu;
      }
      const icon_menu = this.site?.icon_menu?.menu || [];
      for (let item of list) {
        if (item.name == "report") {
          item.noti = this.notificationData.report_admin || false;
        } else if (item.name == "request") {
          item.noti = this.notificationData.report_user || false;
        } else if (item.name == "warranty") {
          item.noti = this.notificationData.report_user_warranty || false;
        }
        const model = icon_menu.find((x) => x.name == item.name);
        if (model) {
          item.type = model.type;
          item.symbol = model.symbol;
        }
      }
      return list;
    },
  },
};
</script>

<style lang="css" scoped>
.selected {
  border-top: 2px solid red;
}
.footer {
  background: transparent !important;
  /* min-width: 65px !important; */
  width: 100%;
  height: 100% !important;
}
</style>
